import { HeaderProps } from '@lib/types';
import GenericText, { TextVariant } from '@ui/Text/GenericText';
import Unicase from '@ui/Unicase/Unicase';
import { isElementExistInHeader } from '@utils/validations';

export type HeaderTextProps = Pick<HeaderProps, 'unicase' | 'unicaseIsPill' | 'title' | 'description' | 'className'> & {
  descriptionClassName?: string;
};

export default function HeaderText({
  unicase,
  unicaseIsPill,
  title,
  description,
  className,
  descriptionClassName,
}: HeaderTextProps) {
  if (!isElementExistInHeader({ unicase, title, description }, ['unicase', 'title', 'description'])) {
    return null;
  }
  const unicaseContent =
    unicase && 'value' in unicase
      ? unicase.value
      : unicase && 'unicase' in unicase
        ? unicase.unicase?.value
        : undefined;

  return (
    <div className={className ?? 'flex flex-col gap-2'}>
      <Unicase content={unicaseContent} isPill={unicaseIsPill} />
      <GenericText content={title} variant={TextVariant.TitleMD} />
      <GenericText content={description} variant={TextVariant.TextBodyLG} className={descriptionClassName} />
    </div>
  );
}
